export default __webpack_public_path__ + "static/media/logoAlagoas.7086ee8d.png";